import { render, staticRenderFns } from "./IconAchievement.vue?vue&type=template&id=b91fc9b8"
import script from "./IconAchievement.vue?vue&type=script&lang=js"
export * from "./IconAchievement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports